import SuccessToast from './components/SuccessToast';
import ErrorToast from './components/ErrorToast';
import CustomToast from './components/CustomToast/CustomToast';
import type { CustomToastMessageProps } from './components/CustomToast/CustomToast.types';
import { BaseToastProps } from 'react-native-toast-message';

export const toastConfig = {
  success: (props: BaseToastProps) => <SuccessToast {...props} />,
  error: (props: BaseToastProps) => <ErrorToast {...props} />,
  custom: (props: BaseToastProps) => {
    const p = props as CustomToastMessageProps;
    return <CustomToast {...p} {...(p.props ?? {})} />;
  },
};
